/**
 * @description
 * enum for the QuickButtonComplex content type
 * @enum QuickButtonComplexContentType
 */
export var QuickButtonComplexContentType;
(function (QuickButtonComplexContentType) {
    QuickButtonComplexContentType["WITH_INITIALS"] = "WITH_INITIALS";
    QuickButtonComplexContentType["WITH_ICON"] = "WITH_ICON";
    QuickButtonComplexContentType["WITH_IMAGE"] = "WITH_IMAGE";
})(QuickButtonComplexContentType || (QuickButtonComplexContentType = {}));
//# sourceMappingURL=content.js.map